import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import { Small, MediumUp } from 'components/MediaQuery';

const SecondaryPromoHeroBackgroundImage = ({ image }) => {
  const landscapeImage = get(image, 'landscape');
  const portraitImage = get(image, 'portrait');

  return (
    <>
      <Small>
        <Image
          className="HomepageV2SecondaryPromoHero__background-image Lazy"
          src={get(portraitImage, 'src')}
          alt={get(portraitImage, 'alt')}
          width={get(portraitImage, 'width')}
          height={get(portraitImage, 'height')}
          role="presentation"
          coverParentNode
        />
      </Small>
      <MediumUp>
        <Image
          className="HomepageV2SecondaryPromoHero__background-image Lazy"
          src={get(landscapeImage, 'src')}
          alt={get(landscapeImage, 'alt')}
          width={get(landscapeImage, 'width')}
          height={get(landscapeImage, 'height')}
          role="presentation"
          coverParentNode
        />
      </MediumUp>
      <style jsx>
        {`
          .HomepageV2SecondaryPromoHero__background-image {
            width: 100%;
            height: 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            order: 1;
          }
        `}
      </style>
    </>
  );
};

const assetPropType = PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string });

SecondaryPromoHeroBackgroundImage.propTypes = {
  image: PropTypes.shape({
    landscape: assetPropType.isRequired,
    portrait: assetPropType.isRequired,
  }).isRequired,
};

export default SecondaryPromoHeroBackgroundImage;
